export default __webpack_public_path__ + "static/media/1.680d8855.gif";